import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/orderlist/orderdetailsbg@2x.png';
import _imports_1 from '@assets/images/orderlist/yiqichouicon.png';
const _withScopeId = n => (_pushScopeId("data-v-14fedb8b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "details-box"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "content-bg",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/after_sale/after_sale_ing.png",
  alt: ""
}, null, -1));
const _hoisted_5 = {
  class: "span"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "righticon"
})], -1));
const _hoisted_7 = {
  key: 3,
  class: "cash-back"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cashCover",
  src: "https://p6.moimg.net/mdwxapp/order_detail_cash_back.png"
}, null, -1));
const _hoisted_9 = {
  class: "cashMonyeInfo"
};
const _hoisted_10 = {
  class: "cashMoney"
};
const _hoisted_11 = {
  key: 0,
  class: "moneyPre"
};
const _hoisted_12 = {
  key: 0,
  class: "cashDes"
};
const _hoisted_13 = {
  class: "cashStatusInfo"
};
const _hoisted_14 = {
  class: "statusName"
};
const _hoisted_15 = {
  class: "cashTime",
  "wx:if": "{{orderInfo.cashback_vo.time}}"
};
const _hoisted_16 = {
  key: 4,
  class: "remark"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("span", null, "订单备注")], -1));
const _hoisted_18 = {
  class: "remarktext"
};
const _hoisted_19 = {
  class: "order_paper"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订单号", -1));
const _hoisted_21 = ["copyData"];
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "copyicon"
}, "复制", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下单时间", -1));
const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "付款时间", -1));
const _hoisted_26 = {
  key: 1
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "定金支付时间", -1));
const _hoisted_28 = {
  key: 2
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "尾款支付时间", -1));
const _hoisted_30 = {
  key: 3
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "一起筹ID", -1));
const _hoisted_32 = /*#__PURE__*/_createTextVNode("查看详情 ");
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_1
}, null, -1));
const _hoisted_34 = [_hoisted_32, _hoisted_33];
const _hoisted_35 = ["innerHTML"];
const _hoisted_36 = {
  key: 1,
  class: "refoundtips"
};
const _hoisted_37 = {
  class: "box"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "配捐资金将原路退回的原因:", -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("p", null, "1、众筹项目失败;"), /*#__PURE__*/_createElementVNode("p", null, "2、众筹项目被发起者或摩点取消;"), /*#__PURE__*/_createElementVNode("p", null, "3、众筹项目发起者主动发起退款;"), /*#__PURE__*/_createElementVNode("p", null, "4、其他")], -1));
const _hoisted_40 = {
  class: "evaluate-gift-wrap"
};
const _hoisted_41 = {
  class: "evaluate-gift-inner"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bg-img"
}, null, -1));
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "gift-notice"
}, "恭喜你，获得评价礼包", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_detailsHeader = _resolveComponent("detailsHeader");
  const _component_detailsAddress = _resolveComponent("detailsAddress");
  const _component_detailsContent = _resolveComponent("detailsContent");
  const _component_detailsStatus = _resolveComponent("detailsStatus");
  const _component_dialog_btn = _resolveComponent("dialog-btn");
  const _component_orderAppeal = _resolveComponent("orderAppeal");
  const _component_orderTel = _resolveComponent("orderTel");
  const _component_orderRemark = _resolveComponent("orderRemark");
  const _component_orderRefund = _resolveComponent("orderRefund");
  const _component_topay = _resolveComponent("topay");
  const _component_openboxlist = _resolveComponent("openboxlist");
  const _component_openCardlist = _resolveComponent("openCardlist");
  const _component_orderProjectRefund = _resolveComponent("orderProjectRefund");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$setup.orderInfo ? (_openBlock(), _createBlock(_component_detailsHeader, {
    key: 0,
    orderInfo: $setup.orderInfo
  }, null, 8, ["orderInfo"])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(['details-content', {
      content: $data.env.isSafari() && $data.env.isIos()
    }])
  }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, $setup.orderInfo.aftersale_info && $setup.orderInfo.aftersale_info.status == 2 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "aftersale",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toAftersaleDetails && $options.toAftersaleDetails(...args))
  }, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString($setup.orderInfo.aftersale_info.title), 1), _hoisted_6])) : _createCommentVNode("", true), $setup.orderInfo ? (_openBlock(), _createBlock(_component_detailsAddress, {
    key: 1,
    type: "product",
    orderInfo: $setup.orderInfo
  }, null, 8, ["orderInfo"])) : _createCommentVNode("", true), $setup.orderInfo ? (_openBlock(), _createBlock(_component_detailsContent, {
    key: 2,
    orderInfo: $setup.orderInfo,
    onOpenboxmore: $options.openboxmore,
    onOpenrefund: $options.openrefund
  }, null, 8, ["orderInfo", "onOpenboxmore", "onOpenrefund"])) : _createCommentVNode("", true), $setup.orderInfo.cashback_vo ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [$options.isNumber($setup.orderInfo.cashback_vo.cashback_amount) ? (_openBlock(), _createElementBlock("text", _hoisted_11, "￥")) : _createCommentVNode("", true), _createTextVNode(_toDisplayString($setup.orderInfo.cashback_vo.cashback_amount), 1)]), $setup.orderInfo.cashback_vo.title ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($setup.orderInfo.cashback_vo.title), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString($setup.orderInfo.cashback_vo.status_name), 1), _createElementVNode("div", _hoisted_15, _toDisplayString($setup.orderInfo.cashback_vo.time), 1)])])) : _createCommentVNode("", true), $setup.orderInfo.remark ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, _toDisplayString($setup.orderInfo.remark), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [_createElementVNode("p", null, [_hoisted_20, _createElementVNode("span", {
    onClick: _cache[1] || (_cache[1] = (...args) => $options.copy && $options.copy(...args)),
    ref: "copy",
    copyData: $setup.orderInfo.order_id
  }, [_createTextVNode(_toDisplayString($setup.orderInfo.order_id) + " ", 1), _hoisted_22], 8, _hoisted_21)]), _createElementVNode("p", null, [_hoisted_23, _createElementVNode("span", null, _toDisplayString($setup.orderInfo.ctime), 1)]), $setup.orderInfo.pay_time ? (_openBlock(), _createElementBlock("p", _hoisted_24, [_hoisted_25, _createElementVNode("span", null, _toDisplayString($setup.orderInfo.pay_time), 1)])) : _createCommentVNode("", true), $setup.orderInfo.first_pay_time ? (_openBlock(), _createElementBlock("p", _hoisted_26, [_hoisted_27, _createElementVNode("span", null, _toDisplayString($setup.orderInfo.first_pay_time), 1)])) : _createCommentVNode("", true), $setup.orderInfo.tail_pay_time ? (_openBlock(), _createElementBlock("p", _hoisted_28, [_hoisted_29, _createElementVNode("span", null, _toDisplayString($setup.orderInfo.tail_pay_time), 1)])) : _createCommentVNode("", true), $setup.orderInfo.teamfund_id ? (_openBlock(), _createElementBlock("p", _hoisted_30, [_hoisted_31, _createElementVNode("span", null, [_createTextVNode(_toDisplayString($setup.orderInfo.teamfund_id) + " ", 1), _createElementVNode("a", {
    onClick: _cache[2] || (_cache[2] = (...args) => $options.lookTeamfund && $options.lookTeamfund(...args)),
    href: "#",
    style: {}
  }, _hoisted_34)])])) : _createCommentVNode("", true)])])], 2), _createElementVNode("div", {
    class: "html",
    ref: "html",
    innerHTML: $data.html
  }, null, 8, _hoisted_35), $data.openrefundShow ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_hoisted_38, _hoisted_39, _createElementVNode("div", {
    class: "btn",
    onClick: _cache[3] || (_cache[3] = $event => $data.openrefundShow = false)
  }, "知道了")])])) : _createCommentVNode("", true), $setup.orderInfo ? (_openBlock(), _createBlock(_component_detailsStatus, {
    key: 2,
    onShow_dialog: $options.show_dialog,
    butttonList: $setup.orderInfo.status_data.btn_list,
    onToOp: _cache[4] || (_cache[4] = e => $options.op(e))
  }, null, 8, ["onShow_dialog", "butttonList"])) : _createCommentVNode("", true), _createVNode(_component_dialog_btn, {
    dialog_show: $data.dialog_show,
    onToParent: $options.close_dialog,
    dialog_btn: $data.dialog_btn,
    list: true,
    onToOp: _cache[5] || (_cache[5] = e => {
      $options.op(e);
      $options.close_dialog();
    })
  }, null, 8, ["dialog_show", "onToParent", "dialog_btn"]), $data.appealShow ? (_openBlock(), _createBlock(_component_orderAppeal, {
    key: 3,
    onOk: _cache[6] || (_cache[6] = $event => $options.close('appealShow')),
    onDialogBack: _cache[7] || (_cache[7] = $event => $data.appealShow = false),
    orderId: $setup.orderId,
    orderType: _ctx.orderType,
    orderInfo: $setup.orderInfo
  }, null, 8, ["orderId", "orderType", "orderInfo"])) : _createCommentVNode("", true), $data.telShow ? (_openBlock(), _createBlock(_component_orderTel, {
    key: 4,
    onOk: _cache[8] || (_cache[8] = $event => $options.close('telShow')),
    onDialogBack: _cache[9] || (_cache[9] = $event => $data.telShow = false),
    orderId: $setup.orderId,
    orderInfo: $setup.orderInfo
  }, null, 8, ["orderId", "orderInfo"])) : _createCommentVNode("", true), $data.remarkShow ? (_openBlock(), _createBlock(_component_orderRemark, {
    key: 5,
    onOk: _cache[10] || (_cache[10] = $event => $options.close('remarkShow')),
    onDialogBack: _cache[11] || (_cache[11] = $event => $data.remarkShow = false),
    orderId: $setup.orderId,
    remark: $setup.orderInfo.remark || '',
    orderInfo: $setup.orderInfo
  }, null, 8, ["orderId", "remark", "orderInfo"])) : _createCommentVNode("", true), _createVNode(_component_orderRefund, {
    orderRefundShow: $data.orderRefundShow,
    onDialogBack: _cache[12] || (_cache[12] = $event => $data.orderRefundShow = false),
    onToOp: _cache[13] || (_cache[13] = e => $options.refundFn(e, _ctx.orderitem)),
    orderType: _ctx.orderType,
    orderInfo: $setup.orderInfo
  }, null, 8, ["orderRefundShow", "orderType", "orderInfo"]), $data.payShow ? (_openBlock(), _createBlock(_component_topay, {
    key: 6,
    class: "topay",
    orderInfo: $setup.orderInfo,
    pay_resource: $data.pay_resource,
    list: $data.methodsList,
    onClose: _cache[14] || (_cache[14] = $event => $data.payShow = false),
    onPayClick: $options.payClick
  }, null, 8, ["orderInfo", "pay_resource", "list", "onPayClick"])) : _createCommentVNode("", true), _createVNode(_component_dialog_btn, {
    dialog_show: $data.dialog_address,
    onToParent: _cache[15] || (_cache[15] = $event => $data.dialog_address = false),
    dialog_btn: $data.addressBtn,
    order_type: _ctx.order_type,
    list: true,
    onToOp: _cache[16] || (_cache[16] = e => $options.toAddress(e, _ctx.orderitem, _ctx.orderType))
  }, null, 8, ["dialog_show", "dialog_btn", "order_type"]), $data.openboxmoreMod ? (_openBlock(), _createBlock(_component_openboxlist, {
    key: 7,
    orderInfo: $setup.orderInfo,
    orderId: $setup.orderId,
    onClose: _cache[17] || (_cache[17] = $event => $data.openboxmoreMod = false)
  }, null, 8, ["orderInfo", "orderId"])) : _createCommentVNode("", true), $data.openCardlistMod ? (_openBlock(), _createBlock(_component_openCardlist, {
    key: 8,
    orderInfo: $setup.orderInfo,
    orderId: $setup.orderId,
    onClose: _cache[18] || (_cache[18] = $event => $data.openCardlistMod = false)
  }, null, 8, ["orderInfo", "orderId"])) : _createCommentVNode("", true), $data.refundInfo ? (_openBlock(), _createBlock(_component_orderProjectRefund, {
    key: 9,
    show: $data.orderProjectRefundShow,
    info: $data.refundInfo,
    onClosePopup: _cache[19] || (_cache[19] = $event => $data.orderProjectRefundShow = false),
    onGoNext: $options.goNext
  }, null, 8, ["show", "info", "onGoNext"])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_hoisted_42, _hoisted_43, _createElementVNode("div", {
    class: "gift-confirm",
    onClick: _cache[20] || (_cache[20] = $event => $options.op({
      'type': 'order_comment_add'
    }))
  }, " 立即评论 ")])], 512), [[_vShow, $data.giftWrapShow]])]);
}